import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomepageComponent } from './components/core/home/homepage/homepage.component';
import { LoginComponent } from './components/Authentication/login/login.component';
import { ChangePasswordComponent } from './components/Authentication/change-password/change-password.component';
import { authGuard } from './guards/auth.guard';
import { roleGuard } from './guards/role.guard';
import { NodataComponent } from './shared/nodata/nodata.component';
import { NointernetComponent } from './components/core/static pages/nointernet/nointernet.component';
import { JobsfullpageComponent } from './components/core/jobs/jobsfullpage/jobsfullpage.component';
import { JobsdetailsComponent } from './components/core/jobs/jobsdetails/jobsdetails.component';
import { BlogsfullpageComponent } from './components/core/blogs/blogsfullpage/blogsfullpage.component';
import { BlogdetailsComponent } from './components/core/blogs/blogdetails/blogdetails.component';
import { FaqsComponent } from './components/core/faqs/faqs/faqs.component';
import { CreatecompanyComponent } from './components/core/iamhiring/createcompany/createcompany.component';
import { CreateJobComponent } from './components/core/jobs/create-job/create-job.component';
import { AboutUsComponent } from './components/core/static pages/about-us/about-us.component';
import { ContactUsComponent } from './components/core/static pages/contact-us/contact-us.component';
import { SmartsearchComponent } from './components/core/jobs/smartsearch/smartsearch.component';
import { PoliciesComponent } from './components/core/policies/policies/policies.component';
import { TermsandcondComponent } from './components/core/policies/termsandcond/termsandcond.component';
import { OurservicesComponent } from './components/core/static pages/ourservices/ourservices.component';
import { ResigteringComponent } from './components/Authentication/resigtering/resigtering.component';
import { AddreviewComponent } from './components/core/profile/addreview/addreview.component';
import { MyappliesComponent } from './components/core/profile/myapplies/myapplies.component';
import { MychatticketsComponent } from './components/core/profile/mychattickets/mychattickets.component';
import { MyjobsComponent } from './components/core/profile/myjobs/myjobs.component';
import { MyprofileComponent } from './components/core/profile/myprofile/myprofile.component';
import { MyprofilecompanyComponent } from './components/core/profile/myprofilecompany/myprofilecompany.component';
import { ApplyfordoctorComponent } from './components/core/jobs/applyfordoctor/applyfordoctor.component';
import { ApplyfordentistComponent } from './components/core/jobs/applyfordentist/applyfordentist.component';

const routes: Routes = [

  { path: 'no-data', component: NodataComponent},
  { path: 'create-user', component: ResigteringComponent},
  { path: 'addreview', component: AddreviewComponent, canActivate: [authGuard, roleGuard], data: { allowedUserTypes: ['candidate', 'admin'] } },
  { path: 'applyed', component: MyappliesComponent, canActivate: [authGuard, roleGuard], data: { allowedUserTypes: ['candidate', 'admin'] } },
  { path: 'Mychats/:id', component: MychatticketsComponent, canActivate: [authGuard] },
  { path: 'Mychats', component: MychatticketsComponent, canActivate: [authGuard] },
  { path: 'myjobs', component: MyjobsComponent, canActivate: [authGuard, roleGuard], data: { allowedUserTypes: ['company', 'admin'] } },
  { path: 'profile', component: MyprofileComponent, canActivate: [authGuard, roleGuard], data: { allowedUserTypes: ['candidate', 'admin'] } },
    { path: 'companyprofile', component: MyprofilecompanyComponent, canActivate: [authGuard, roleGuard], data: { allowedUserTypes: ['company', 'admin'] } },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [authGuard] },

  { path: 'Login', component: LoginComponent },
  { path: 'Home', component: HomepageComponent },
    { path: 'jobs', component: JobsfullpageComponent },
      { path: 'create-job', component: CreateJobComponent, canActivate: [roleGuard], data: { allowGuest: true, allowedUserTypes: ['company', 'admin'] } },
           { path: 'about-us', component: AboutUsComponent },
           { path: 'contact', component: ContactUsComponent },
     { path: 'job/:id', component: JobsdetailsComponent },
     { path: 'apply/doctor/:id', component: ApplyfordoctorComponent },
     { path: 'apply/dentist/:id', component: ApplyfordentistComponent },
        { path: 'blogs', component: BlogsfullpageComponent },
       { path: 'blog/:id', component: BlogdetailsComponent },
        { path: 'faqs', component: FaqsComponent },
           { path: 'iamhiring', component: CreatecompanyComponent, canActivate: [roleGuard], data: { allowGuest: true, allowedUserTypes: ['admin'] } },
         { path: 'smartapply', component: SmartsearchComponent, canActivate: [roleGuard], data: { allowGuest: true, allowedUserTypes: ['candidate', 'admin'] } },
           { path: 'policies', component: PoliciesComponent },
                   { path: 'terms-and-conditions', component: TermsandcondComponent },
             { path: 'services', component: OurservicesComponent },
  { path: 'no-internet', component: NointernetComponent },
  { path: '', redirectTo: 'Home', pathMatch: 'full' },
  { path: '**', redirectTo: 'Home', pathMatch: 'full' },
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
